import script from "./updatePwd.vue?vue&type=script&lang=ts&setup=true"
export * from "./updatePwd.vue?vue&type=script&lang=ts&setup=true"

import "./updatePwd.vue?vue&type=style&index=0&id=c0c58340&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c58340"]])

export default __exports__